import { SvgIcon, SvgIconProps } from '@mui/material';

const DoneIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      sx={{ width: 24, height: 24, fill: 'none' }}
      viewBox="0 0 24 24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 12L10 17L20 7"
        stroke={props.stroke ? props.stroke : 'white'}
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </SvgIcon>
  );
};

export default DoneIcon;
